import React from 'react'
import Alert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'

function ContactFormSubmittedAlert ({ show, type, message, onClose }) {
  return (
    <Snackbar
      open={show}
      autoHideDuration={5000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
      onClose={(event, reason) => reason !== 'clickaway' && onClose() }
    >
      <Alert
        severity={type}
        variant="filled"
        sx={{
          '& .MuiAlert-icon': {
            fontSize: '28px'
          },
          '& .MuiAlert-message': {
            fontFamily: 'Kanit, sans-serif',
            fontWeight: '300',
            fontSize: '18px'
          }
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  )
}

export default ContactFormSubmittedAlert
